import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems, goalQuestions, stats } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-96" data-mp="26n5ue4abpvzc">
      <div className="mx-auto max-w-5xl" data-id="element-97" data-mp="22kr9len3gm5f">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-98" data-mp="22m2ejhs9zzy4">
          From "Should I Take This Case?" to{" "}
          <em className="italic text-brand" data-id="element-99" data-mp="2uc6yjfc4ikyt">"I Know Exactly What I Need to Evaluate Next."</em>
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-center text-[17px] leading-relaxed text-ink-muted md:text-lg" data-id="element-100" data-mp="2q9u25hj9nzep">
          <p data-id="element-101" data-mp="2lah563yolbye">I created the Implant Planning Playbook™ for one simple reason: I know what it feels like to look at an implant case and realize that the difficult part isn't the implant itself.</p>
          <p className="font-semibold text-ink" data-id="element-102" data-mp="19v27sz2k8i2r">The difficult part is everything you need to decide before the implant is placed. That's why I built this system around the actual sequence of clinical decisions.</p>
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4" data-id="element-103" data-mp="1c3nvebjemk08">
          {stats.map(s => <div key={s.label} className="rounded-2xl bg-navy p-5 text-center" data-id="element-104" data-mp="y6sdrup37k8k">
              <dt className="sr-only" data-id="element-105" data-mp="131xumf3mu8ps">{s.label}</dt>
              <dd className="font-serif text-4xl font-black text-white md:text-5xl" data-id="element-106" data-mp="oecturu8cll1">{s.value}</dd>
              <dd className="mt-1 text-xs font-bold uppercase leading-snug tracking-wide text-brand-sky" data-id="element-107" data-mp="t64md7wy51dt">{s.label}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-108" data-mp="fc3ki5ap6y98">
          <div className="rounded-3xl border-2 border-danger/20 bg-danger-light p-6 md:p-8" data-id="element-109" data-mp="jgte1nhvw0qz">
            <h3 className="flex items-center gap-2 font-serif text-2xl font-extrabold text-danger" data-id="element-110" data-mp="5fqtjf6jeyi6">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-danger" data-id="element-111" data-mp="ae209h1jcsw6">
                <XIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-112" data-mp="2c5awdmmnl8fx" />
              </span>
              Before
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-113" data-mp="27c9ct1bi4kq0">
              {beforeItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-114" data-mp="23ch1iguq40gy">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-115" data-mp="1ydxhwn3lr0rr" />
                  {t}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-navy p-6 md:p-8" data-id="element-116" data-mp="2r1a0km6n6ofs">
            <h3 className="flex items-center gap-2 font-serif text-2xl font-extrabold text-white" data-id="element-117" data-mp="2qzp8d37svhl3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-cta" data-id="element-118" data-mp="2m49x8j16fzsd">
                <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-119" data-mp="2h5q7e7jgq3uq" />
              </span>
              With the Playbook™
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-120" data-mp="15n5m3qqg8e4y">
              {afterItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-white" data-id="element-121" data-mp="vks5m800i2ij">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-122" data-mp="10j3fgiqb4d0r" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl rounded-3xl bg-brand-light p-6 text-center md:p-10" data-id="element-123" data-mp="1a8wigvcdvjte">
          <p className="font-serif text-2xl font-extrabold text-navy" data-id="element-124" data-mp="1eb02i8d4bwqa">My goal is simple:</p>
          <p className="mt-3 text-[17px] text-ink-muted" data-id="element-125" data-mp="1j9ku5jeb1834">A system you can open whenever you receive an implant case and immediately know:</p>
          <ul className="mt-5 space-y-3" data-id="element-126" data-mp="1oa8uwwsc53aj">
            {goalQuestions.map(q => <li key={q} className="rounded-xl bg-white px-4 py-3 text-lg font-bold text-navy shadow-sm" data-id="element-127" data-mp="1t6zbdl81y0wh">{q}</li>)}
          </ul>
        </div>

        <SectionCTA label="I Want a Repeatable Planning System" data-id="element-128" data-mp="3q2nc1tn223pw" />
      </div>
    </section>;
}